import type { SEOPropsType } from '..';

export const SEO_CLINDAMYCIN_CONTENT: SEOPropsType = {
  title: 'Clindamycin Prescription - Curology Custom Formula',
};
